<template>
  <div class="social-copy social-share">
    <button @click="copy"
            :class="['copy-button', {'copy-button--tooltip' : tooltipVisible}]"
            :data-copied-text="tooltip"
            v-tag:useractionevent="tagging"
            :aria-label="ariaLabel"
            ref="copyButton">
      <slot/>
    </button>
    <div class="is-sr-only" aria-live="polite">
      <span v-if="tooltipVisible">{{tooltip}}</span>
    </div>
    <span ref="copyTooltip" class="hidden"/>
  </div>
</template>

<script>
  import { tag } from '@Foundation/analyticsHandler';
  export default {
    name: 'social-copy',
    directives: {
      tag
    },
    props: {
      tagging: {
        required: true,
        type: Object
      },
      url: {
        required: true,
        type: String
      },
      tooltip: {
        type: String,
        required: false,
        default: 'Copied!'
      },
      ariaLabel: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        tooltipVisible: false,
        textarea: null
      };
    },
    methods: {
      isOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      },
      copy() {
        this.textarea = this.generateTextarea();
        document.body.appendChild(this.textarea);

        /* istanbul ignore next */
        if (this.isOS()) {
          const range = document.createRange();
          range.selectNodeContents(this.textarea);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          this.textarea.setSelectionRange(0, 999999);
        } else {
          this.textarea.select();
        }

        /* istanbul ignore next */
        this.copyText(this.textarea);
        this.$refs.copyButton.focus();
      },
      generateTextarea() {
        const el = document.createElement('textarea');
        el.value = this.url;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        return el;
      },
      showTooltip() {
        this.tooltipVisible = true;
      },
      hideTooltip() {
        setTimeout(() => {
          this.tooltipVisible = false;
        }, 3000);
      },
      copyText() {
        /* istanbul ignore next */
        try {
          return document.execCommand('copy');
        } catch (err) {
          /* eslint-disable no-console */
          console.warn('Copy to clipboard failed', err);
          return false;
        } finally {
          document.body.removeChild(this.textarea);
          this.showTooltip();
          this.hideTooltip();
        }
      }
    }
  };
</script>

<style src="./SocialCopy.scss" lang="scss">